export default __webpack_public_path__ + "static/media/volkihar-armor-large.2c58b178.png";